const TitleTabs = (props) => {
    const { title, notification } = props
    return (
        <div className="d-flex align-center">
            <label className="pt-3 pointer">{title}</label> {notification !== undefined && <span className="title-tabs-notification">{notification}</span>}
        </div>
    )
}

export default TitleTabs